import { Component, OnInit } from '@angular/core';
import {ServerNotificationService} from "@catcore/services/server-notification.service";
import Timer = NodeJS.Timer;

@Component({
  selector: 'cat-progress-header',
  templateUrl: './progress-header.component.html',
  styleUrls: ['./progress-header.component.scss']
})
export class ProgressHeaderComponent implements OnInit {

  MSG_TYPE_PROCESS_START = 0;
  MSG_TYPE_PROCESS_END = 2;
  MSG_TYPE_ERROR = 3;

  processAboutToRun: boolean = false;
  processRunning: boolean = false;
  currentProgress: number = 0;

  processAboutToRunTimer: Timer;

  constructor(private serverNotificationService: ServerNotificationService) { }

  ngOnInit() {
    this.serverNotificationService.messages.subscribe((msgs) => {
        msgs.forEach((msg) => {
          this.consumeMessage(msg);
        });
      },
      (error) => {
        this.resetProgress();
      },
      () => {
        this.resetProgress();
      }
    );

    this.serverNotificationService.signalProcessStart.subscribe((started) => {
      if (started) {
        console.log('A process is about to start');
        this.processAboutToRun = true;
        if (!this.processRunning) {
          this.currentProgress = 0;
        }
        if (this.processAboutToRunTimer) {
          clearTimeout(this.processAboutToRunTimer);
        }
        this.processAboutToRunTimer = setTimeout(() => {
          console.log('Timeout for processAboutToRun');
          this.processAboutToRun = false;
        }, 30000);
      }
    })
  }

  isConnected() {
    return this.serverNotificationService.isConnected();
  }

  reconnect() {
    this.serverNotificationService.connect();
  }

  progressSpinnerClick() {
    this.serverNotificationService.show();
  }

  protected consumeMessage(msg) {
    switch(msg.type) {
      case this.MSG_TYPE_PROCESS_END:
      case this.MSG_TYPE_ERROR:
        this.resetProgress();
        break;
      default:
        if (msg.totalSteps) {
          this.processRunning = true;
          if (msg.step) {
            this.updateProgress(msg.step, msg.totalSteps);
          }
        }
    }
  }

  protected updateProgress(step, totalSteps) {
    if (totalSteps > 0) {
      this.currentProgress = Math.round(step * 100 / totalSteps);
      if (this.currentProgress > 100) {
        this.currentProgress = 100;
      }
    } else {
      this.currentProgress = 0;
    }
  }

  private resetProgress() {
    this.currentProgress = 0;
    this.processRunning = false;
    this.processAboutToRun = false;
  }

  isProcessRunning() {
    return this.isConnected() && (this.processAboutToRun || this.processRunning);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/ui-base/components/progress-header/progress-header.component.ts